export default __webpack_public_path__ + "71ca2f3822567be468f9bd020821ddfe.png";